import { Provider } from './provider';

export abstract class AssetProvider extends Provider {
  /**
   * Resolve asset url to absolute url
   * @param assetUrl An asset url, usually starts with "asset://"
   * @return The absolute url of the asset
   */
  abstract getAsset(assetUrl: string): string;

  /**
   * Add asset to the provider, usually this involves uploading the asset to a server
   * @param dataUrl
   * @return An object containing the url of the added asset
   */
  abstract addAsset(dataUrl: string): Promise<{
    url: string;
  }>;
}
